var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem2C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7 77.8c-9.7-3-16.4-6.8-20.2-11.3v98.4c3.7 4.6 10.4 8.3 20.2 11.3V77.8z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 66.9c-2.6 3.1-6.6 5.8-12.1 8.1v98.4c5.5-2.3 9.5-5 12.1-8.1V66.9z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8 80.3c-2.7-.5-5.4-1.1-8.1-1.8v98.4c2.7.7 5.4 1.3 8.1 1.8V80.3z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9 81.2c-1.2-.1-2.4-.2-3.6-.4v98.4c1.2.2 2.4.3 3.6.4V81.2z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m696.9 61.5-25.7 19.2v98.4l25.7-19.4V61.5z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617.4 81.6-28.1-18.9v98.4l28.1 18.7V81.6z",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m696.9 61.6-28.2-18.7-53.8.5-25.5 19.2 28.1 18.9 53.8-.7 25.6-19.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671.3 80.8-53.8.7v98.2l53.8-.5V80.8z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m669.2 42.2-.2-.2-54.5.5-.2.2L588.8 62l-.4.4v99.3l.4.2 28.1 18.7.4.2 54.3-.5.2-.2 25.7-19.4.4-.2V61.1l-.4-.2-28.3-18.7m-.8 1.6L696 62.1v97.3l-25.1 19-53.3.5-27.4-18.2V63.1l24.9-18.8 53.3-.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.7 81.9h.8c32.7-1.6 50.2-9.2 52.4-22.7-3.7-13.1-21.6-20.2-53.6-21.4h-1.6c-32.8 1.6-50.3 9.2-52.4 22.7 3.8 13.2 21.9 20.3 54.4 21.4z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474.8 60v-.7c-.3-3.4-1.9-6.4-4.9-9-4.6-4.1-11.2-7.3-20-9.5-8.8-2.4-18.8-3.7-29.9-3.8h-1.4c-15.1.3-27.6 2.6-37.6 6.8-4.7 2-8.5 4.3-11.3 7-2.9 2.8-4.3 5.8-4.3 9v.7c.3 3.3 1.9 6.3 4.9 9 4.6 4 11.2 7.2 20 9.5 8.8 2.5 18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.2-5.7 4.3-9m-17.5-15.1c4.7 2 8.5 4.3 11.3 6.7 2.7 2.6 4.1 5.2 4.3 7.7v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.8-10.1 6.9-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4-11.3-6.5-2.7-2.5-4.1-5.2-4.3-7.9v-.5c0-2.6 1.3-5.2 3.8-7.7 3.9-3.7 10.1-6.8 18.5-9.4 8.3-2.4 18-3.7 29.1-4h1.4c14.8.2 27.2 2.2 37.2 6.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91.5 61.7 78.3 30.2 74.1-32-78.3-30.2-74.1 32z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9 158.2V59.8l-74.1 32V190l74.1-31.8z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8 91.7 91.5 61.5v98.2l78.3 30.2V91.7z",
    style: {
      fill: "#333"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m244.8 59.3-.7-.2L166 28.9l-.4-.2-74.5 32-.5.3v99.7l78.8 30.4.4.2 74.5-32.2.5-.2V59.3m-1.8 1.3v97.1l-73.2 31.6-77.4-29.9V62.1l73.2-31.4L243 60.6zm231.8-1.3c0-.6-.3-.9-.9-.9s-.9.3-.9.9v.7c0 2.6-1.3 5.2-3.8 7.7-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.1-27.3-2.2-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9-.2-.4-.5-.7-1.1-.7-.4 0-.7.3-.7.9V159c.3 3.2 1.9 6.2 4.9 9 4.6 4 11.2 7.1 20 9.5s18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.9-2 8.8-4.3 11.5-7 2.8-2.7 4.3-5.8 4.3-9.2v-99m-4.5 9.8c1-1 1.9-2.1 2.5-3.1v92.3c0 2.8-1.3 5.4-3.8 7.9-4 3.7-10.1 6.8-18.5 9.4-8.3 2.4-18.1 3.7-29.1 4h-1.4c-14.9-.2-27.3-2.3-37.2-6.3-4.7-1.9-8.5-4.1-11.3-6.5-2.7-2.6-4.1-5.2-4.3-7.9v-93c.8 1.3 1.8 2.5 3.1 3.7 4.6 4 11.2 7.1 20 9.5s18.8 3.7 29.9 3.8h1.4c15.1-.3 27.5-2.6 37.4-6.8 4.7-2 8.5-4.3 11.3-7zm-164 85.6c1.4-3.7 3.3-7 5.6-9.9l-5.6 2-5.4-2c2.3 2.9 4.1 6.2 5.4 9.9zm5.6-81.7c-2.3-2.8-4.1-6.1-5.6-9.9-1.3 3.8-3.1 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312.1 73c-2.3-2.8-4.1-6.1-5.6-9.9-1.3 3.8-3.1 7.1-5.4 9.9l5.4-2 5.6 2zm-7 49.1h2.9v25.6h-2.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.1 70.2h2.9v19.7h-2.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 302.897 106.362)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 293.9 118.412)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m169.9 189.4-.4 1.4 5.2 2 .5-1.3-5.3-2.1m10.8 4.3-.5 1.3 5.4 2.2.5-1.4-5.4-2.1m16.2 6.1-5.4-2-.5 1.3 5.4 2.2.5-1.5m10.3 5.6.4-1.4-5.2-2-.5 1.3 5.3 2.1zm36.8-47.9-.5 1.3 5.4 2.2.5-1.3-5.4-2.2m10.8 4.1-.5 1.4 5.4 2 .5-1.3-5.4-2.1m16 6.3-5.4-2.2-.4 1.4 5.2 2 .6-1.2m10.3 5.4.5-1.3-5.4-2.2-.5 1.4 5.4 2.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m148.4 198.5-5.4 2.3.7 1.3 5.2-2.2-.5-1.4m-10.1 6-.5-1.3-5.2 2.2.5 1.4 5.2-2.3m21.2-9.2-.5-1.3-5.4 2.3.5 1.3 5.4-2.3m10.7-4.5-.7-1.3-5.2 2.2.5 1.4 5.4-2.3zm-100-22.6-5.2 2.3.5 1.3 5.2-2.2-.5-1.4m-10.1 6-.5-1.3-5.2 2.2.5 1.4 5.2-2.3m21.2-9.2-.5-1.3-5.4 2.3.7 1.3 5.2-2.3m10.7-4.5-.5-1.3-5.4 2.2.5 1.4 5.4-2.3zm227.2-1.6v-1.4h-25.5v1.4h25.5zm0-98.5V59h-25.5v1.4h25.5zm213.2 94.3c1.3-3.7 3.2-7 5.6-9.9l-5.6 2-5.4-2c2.2 2.9 4 6.2 5.4 9.9zM538 73c-2.4-2.8-4.3-6.1-5.6-9.9-1.4 3.8-3.2 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M538 73c-2.4-2.8-4.3-6.1-5.6-9.9-1.4 3.8-3.2 7.1-5.4 9.9l5.4-2 5.6 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 70.2h2.9v19.7h-2.9zm0 51.9h2.9v25.6h-2.9z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 528.648 106.362)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 519.7 118.412)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 204.4c-3.7-1.3-7-3.1-9.9-5.4l2 5.4-2 5.6c2.9-2.3 6.2-4.1 9.9-5.6zm-92.8 0 2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m377.7 204.4 2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6zm-247.6 3.9c-1.4-1.9-2-3.9-1.6-5.9l-5 3.4-8.6 2.2c1.5-.1 3-.2 4.6-.2 3.9 0 7.5.2 10.6.5zm-62.3-29.1c-5.6 0-10.8-.4-15.7-1.1 1.7 2.2 2.3 4.4 1.8 6.7l6.3-3.6 9.9-2h-2.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8 179.2c-5.6 0-10.8-.4-15.7-1.1 1.7 2.2 2.3 4.4 1.8 6.7l6.3-3.6 9.9-2h-2.3zm217.4 3c-.8-2.2-.7-4.2.5-6.1-4.1.7-8.5 1-13.4 1.1h-2.1l9 1.8 6 3.2zm-62.3 21.5-5.9-3.8c.2 2.6-.7 5.2-2.7 7.6 6-1 12.3-1.6 18.9-1.8l-10.3-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m222.9 203.7-5.9-3.8c.2 2.6-.7 5.2-2.7 7.6 6-1 12.3-1.6 18.9-1.8l-10.3-2zm153.6-.7h26.4v2.9h-26.4zm60.9 0h26v2.9h-26z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 416.447 206.012)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 407.45 220.961)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m280.7 179.9-1.3-2.5-8.8 3.9v3.1zm-59.4 23 1.3 2.7 13.5-6v-3.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 249.648 192.461)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 240.6 207.461)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m59.7 179.7-.9 2.7 12.9 5v-3.1zm65.1 25-18.4-7.1v3.1l17.5 6.7z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 85.447 192.461)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 76.45 207.461)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M693.4 204.4c-3.7-1.3-7-3.1-9.9-5.4l2 5.4-2 5.6c3-2.3 6.3-4.1 9.9-5.6zm-92.8 0 2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m600.6 204.4 2-5.4c-2.9 2.3-6.2 4.1-9.9 5.4 3.7 1.4 7 3.3 9.9 5.6l-2-5.6zm59.6-1.4h26.1v2.9h-26.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M599.6 203h26.1v2.9h-26.1z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 639.447 206.012)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0001 0 0 1 630.4 220.961)",
    style: {
      fontSize: "16.1912px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    cm\n  "), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M545.1 158.9v-1.4h-25.7v1.4h25.7zm0-98.5V59h-25.7v1.4h25.7zM367 205.1v-33.6h-1.4v33.6h1.4zm107.6 0v-33.6h-1.4v33.6h1.4zm115.2 0v-33.6h-1.4v33.6h1.4zm107.9 0v-33.6h-1.4v33.6h1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.4 53c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 162.867 66.568)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M427.3 53c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7s5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 414.768 66.568)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M653.4 53c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 640.917 66.568)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2C);
export default __webpack_public_path__ + "static/media/item2c.b7e267b84a642fffafe03144107d5341.svg";
export { ForwardRef as ReactComponent };